import React, { useState } from 'react';
import { Menu, X, Instagram, Facebook } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const WhatsAppIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-230">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-231" />
  </svg>;
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/aNmuqzhM4ZShZhKE9Q1hg9/WhatsApp_Image_2026-06-01_at_7.48.38_AM_(1)_Nero_AI_Background_Remover_transparent.png';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    // Wait for the mobile menu collapse animation before scrolling
    setTimeout(() => {
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 150);
  };
  const navLinks = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Nosotros',
    href: '#nosotros'
  }, {
    label: 'Servicios',
    href: '#servicios'
  }, {
    label: 'Membresías',
    href: '#membresias'
  }, {
    label: 'Galería',
    href: '#galeria'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <nav className="sticky top-0 z-50 bg-deepblack border-b border-gold" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <div className="flex items-center justify-between h-20 md:h-24" data-id="element-234">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-235">
            <a href="#inicio" data-id="element-236">
              <img src={LOGO_URL} alt="El Rey Barba Barbería" className="h-16 w-16 md:h-20 md:w-20 object-contain" data-id="element-237" />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-238">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-bone hover:text-gold transition-colors text-sm font-medium" data-id="element-239">
                {link.label}
              </a>)}
          </div>

          {/* Right Side - Social Icons + CTA */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-240">
            <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-241">
              <Instagram className="w-5 h-5" data-id="element-242" />
            </a>
            <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-243">
              <Facebook className="w-5 h-5" data-id="element-244" />
            </a>
            <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-245">
              <WhatsAppIcon data-id="element-246" />
            </a>
            <a href="https://wa.me/573028281216?text=Hola%20El%20Rey%20Barba%20%F0%9F%91%91%2C%20quiero%20agendar%20una%20cita%20%F0%9F%92%88" target="_blank" rel="noopener noreferrer" className="bg-gold text-deepblack px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition-colors text-sm" data-id="element-247">
              Agendar Cita 💬
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-gold hover:text-white transition-colors" aria-label="Toggle menu" data-id="element-248">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-249" /> : <Menu className="w-6 h-6" data-id="element-250" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-251">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-black/95 backdrop-blur-lg border-t border-gold" data-id="element-252">
            <div className="px-4 py-6 space-y-4" data-id="element-253">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block text-bone hover:text-gold transition-colors text-lg font-medium" data-id="element-254">
                  {link.label}
                </a>)}
              <div className="flex items-center space-x-6 pt-4 border-t border-gold/30" data-id="element-255">
                <a href="https://instagram.com/barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-256">
                  <Instagram className="w-6 h-6" data-id="element-257" />
                </a>
                <a href="https://facebook.com/Barberiaelreybarba" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-258">
                  <Facebook className="w-6 h-6" data-id="element-259" />
                </a>
                <a href="https://wa.me/573028281216" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-260">
                  <WhatsAppIcon data-id="element-261" />
                </a>
              </div>
              <a href="https://wa.me/573028281216?text=Hola%20El%20Rey%20Barba%20%F0%9F%91%91%2C%20quiero%20agendar%20una%20cita%20%F0%9F%92%88" target="_blank" rel="noopener noreferrer" className="block text-center bg-gold text-deepblack px-5 py-3 rounded-full font-semibold hover:bg-yellow-500 transition-colors" data-id="element-262">
                Agendar Cita 💬
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}